import {
  HOME_ROUTE,
  INSTALLMENT_PAYMENT_ROUTE,
  INSTALLMENT_PAYMENT_ROUTE_CONFIRMATION,
  CONSUMER_CREDIT_ROUTE,
  CONTACT_US_ROUTE,
  OFFICES_ROUTE,
  RATES_AND_FEES_ROUTE,
  PORTABILITY_ROUTE,
  NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE,
  FAQS_ROUTE,
} from './routes.constants';


export const BREADCRUMB_TEXT = {
  [HOME_ROUTE]: 'Inicio',
  [INSTALLMENT_PAYMENT_ROUTE]: 'Pagar cuota',
  [CONSUMER_CREDIT_ROUTE]: 'Crédito de consumo',
  [OFFICES_ROUTE]: 'Sucursales',
  [CONTACT_US_ROUTE]: 'Atención al cliente',
  [RATES_AND_FEES_ROUTE]: 'Tasas y Tarifas',
  [PORTABILITY_ROUTE]: 'Portabilidad financiera',
  [NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE]: 'Información normativa y Bases legales',
  [FAQS_ROUTE]: 'Preguntas frecuentes',
};

export const HOME_BREADCRUMB_TEXT = 'Inicio';

export const SECTION_TITLES = {
  [INSTALLMENT_PAYMENT_ROUTE]: {
    title: '¡Paga tus cuotas, fácil y rápido!',
    class: 'installment-payment-background',
    hasCollapse: false,
    falseLoading: true,
  },
  [INSTALLMENT_PAYMENT_ROUTE_CONFIRMATION]: {
    title: '¡Paga tus cuotas, fácil y rápido!',
    class: 'installment-payment-background',
    hasCollapse: false,
    falseLoading: true,
  },
  [OFFICES_ROUTE]: {
    title: 'Sucursales',
    class: 'generic',
    falseLoading: false,
  },
  [CONTACT_US_ROUTE]: {
    title: 'Atención al cliente',
    class: 'generic',
    falseLoading: false,
  },
  [RATES_AND_FEES_ROUTE]: {
    title: 'Tasas y Tarifas Solventa',
    class: 'generic',
    falseLoading: false,
  },
  [PORTABILITY_ROUTE]: {
    title: 'Portabilidad financiera',
    class: 'generic',
    falseLoading: false,
  },
  [NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE]: {
    title: 'Información Normativa y Bases Legales',
    class: 'generic',
    falseLoading: false,
  },
  [FAQS_ROUTE]: {
    title: 'Preguntas Frecuentes',
    class: 'generic',
    falseLoading: false,
  },
};

export const DEFAULT_TITLE = {
  title: '¡Un Crédito para ti!',
  class: 'generic',
};
